/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{glsl as e}from"../../shaderModules/interfaces.js";import{Texture2DPassUniform as s}from"../../shaderModules/Texture2DPassUniform.js";import{blurSizePixels as r}from"../../../effects/ssao/SSAO.js";function t(t,o){const a=t.fragment;o.receiveAmbientOcclusion?(a.uniforms.add(new s("ssaoTex",((e,s)=>s.ssao?.colorTexture))),a.constants.add("blurSizePixelsInverse","float",1/r),a.code.add(e`float evaluateAmbientOcclusionInverse() {
vec2 ssaoTextureSizeInverse = 1.0 / vec2(textureSize(ssaoTex, 0));
return texture(ssaoTex, gl_FragCoord.xy * blurSizePixelsInverse * ssaoTextureSizeInverse).r;
}
float evaluateAmbientOcclusion() {
return 1.0 - evaluateAmbientOcclusionInverse();
}`)):a.code.add(e`float evaluateAmbientOcclusionInverse() { return 1.0; }
float evaluateAmbientOcclusion() { return 0.0; }`)}export{t as EvaluateAmbientOcclusion};
